(() => {
  'use strict';
  const snapshot = document.getElementById('wg-cart-review-snapshot');
  if (snapshot && !customElements.get('wg-review-snapshot')) {
    customElements.define('wg-review-snapshot', class extends HTMLElement {
      constructor() {
        super();
        this.attachShadow({ mode: 'open' }).append(snapshot.content.cloneNode(true));
      }
    });
  }
  const preload = document.querySelector('[data-wg-cart-review-preload]');
  const widget = preload?.querySelector('valued-widget');
  if (!widget) return;
  let ready = false;

  function mount() {
    const slot = document.querySelector('#CartContainer .wg-cart-review');
    if (!slot || !ready) return;
    const placeholder = slot.querySelector('valued-widget');
    if (placeholder && placeholder !== widget) placeholder.replaceWith(widget);
    slot.setAttribute('data-ready', '');
  }

  // Reuse the already rendered node. A new widget would itself wait for an
  // IntersectionObserver and an asynchronous render on every cart update.
  document.addEventListener('theme:cart:loaded', mount);
  customElements.whenDefined('valued-widget').then(async () => {
    // WebwinkelKeur exposes ready on each widget; wait for its layout and events.
    await widget.ready;
    if (!widget.shadowRoot?.querySelector('[part="widget"]')) return;
    ready = true;
    mount();
  }).catch(() => {
    // Keep the verified visual snapshot when the external widget is unavailable.
  });
})();
